'use client';
import { useEffect, useState } from 'react';

const useReSize = () => {
	const [width, setWidth] = useState<number>(0);
	const [height, setHeight] = useState<number>(0);

	useEffect(() => {
		const ro = new ResizeObserver((entries) => {
			for (const entry of entries) {
				// const cr = entry.contentRect
				// setWidth(cr.width)
				setWidth(window.innerWidth);
				setHeight(window.innerHeight);
			}
		});
		ro.observe(document.body);
	}, []);

	return [width, height];
};

export default useReSize;
